module.exports = __webpack_public_path__ + "media/flags/td-caa2b373.svg";